import { createSelector } from 'reselect';
import i18n from '../../i18n';

import moment from 'moment';

const groupByKey = (list, key) =>
  list.reduce((hash, obj) => ({ ...hash, [obj[key]]: (hash[obj[key]] || []).concat(obj) }), {});

export const selectEventSection = (state) => state.events;
export const selectTripEvents2 = createSelector(
  selectEventSection,
  (state) => state && state.tripEvents
);

export const selectAllTripEvents = (state) => state.events.tripEvents;

export const selectTripEventsSorted = createSelector(selectTripEvents2, (state) => {
  if (!state) {
    return {};
  }

  return groupByKey(state, 'StartDate');
});

export const selectAllGroupedEvents = () =>
  createSelector(selectAllTripEvents, (state) =>
    groupByKey(
      state.map((e) => ({ ...e, StartDate: moment(e.StartDate).format('ddd, MMM DD') })),
      'StartDate'
    )
  );
export const selectTripEvents = (StartDate, EndDate) => (state) => [
  {
    StartDate: StartDate,
    Title: i18n.t('tripHub:TripHubScreen.TripStart'),
    limiter: true,
    notEditable: true,
  },
  ...state.events.tripEvents,
  {
    StartDate: EndDate,
    Title: i18n.t('tripHub:TripHubScreen.TripEnd'),
    limiter: true,
    notEditable: true,
  },
];

export const selectGroupedEvents = (StartDate, EndDate) =>
  createSelector(selectTripEvents(StartDate, EndDate), (state) =>
    groupByKey(
      state
        .sort((a, b) => moment(a.StartDate).valueOf() - moment(b.StartDate).valueOf())
        .map((e) => ({ ...e, StartDate: moment(e.StartDate).format('ddd, MMM DD') })),
      'StartDate'
    )
  );

export const selectFinalGroupedEvents = (StartDate, EndDate) =>
  createSelector(selectGroupedEvents(StartDate, EndDate), (state) => {
    const lastKey = Object.keys(state)[Object.keys(state).length - 1];
    state[lastKey].push({
      StartDate: lastKey,
      Title: i18n.t('tripHub:TripHubScreen.TripEnd'),
      end: true,
      notEditable: true,
    });
    return state;
  });

export const selectTezEventDetails = (state) => state.events?.tezEvent;
export const selectTezEvent = (state) => state.events?.tezEvent?.eventMeeting;
export const selectTezEventPassengers = (state) => state.events?.tezEvent?.passengerList;
export const selectCurrentEvent = (state) => state.events.selectedEvent;
export const selectCventUrl = (state) => state.events.cventUrl;
export const selectTezEventGroup = (state) => state.events?.tezEvent?.groupKey;
